/* Api service for billing's http endpoints */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share, catchError } from 'rxjs/operators';
import { DownloadCsvRequestInterface } from './revenue.interfaces';
import { handleCsvError } from '../http-shared/error-handlers';
import { HostService } from '@vendasta/billing';

@Injectable({ providedIn: 'root' })
export class RevenueApiService {
  constructor(private hostService: HostService, private http: HttpClient) {}

  downloadCsv(r: DownloadCsvRequestInterface): Observable<Blob> {
    const queryParams = `?filename=${r.filename}`;
    return this.http
      .get(this.hostService.hostWithScheme + '/revenue-csv' + queryParams, this.apiOptions())
      .pipe(share(), catchError(handleCsvError));
  }

  private apiOptions(): { responseType: 'blob'; withCredentials: boolean } {
    return {
      responseType: 'blob',
      withCredentials: true,
    };
  }
}
